export const emptyString = '';
export const NA = "N/A";
export const dateTimeDisplayFormat = 'DD MMM YYYY - hh:mm A'; // https://momentjs.com/docs/#/parsing/
export const dateDisplayFormat = 'DD MMM YYYY';